import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Container,
  Button,
  Backdrop,
  CircularProgress,
  Box,
  Tab,
  Tabs,
  FormControl,
  FormControlLabel,
  Checkbox,
  Switch
} from '@material-ui/core';
import moment from 'moment';
import SaveIcon from '@material-ui/icons/Save';
import ReceiptIcon from '@material-ui/icons/Receipt';
import { useParams, useNavigate } from 'react-router-dom';
import Controls from '../controls/Controls';

import { baseUrl, currencies, employers, fileTypes, processStates } from '../../utils/constants';
import DepUploadList from './DepUploadList';
import DepUploadErrors from './DepUploadErrors';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

export default function ProcessDepUploads() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    refId: 0,
    employerRefId: 0,
    ssbFilename: '',
    uploadDate: '',
    uploadedBy: 0,
    processState: 0,
    fileType: 1,
    addRevenue: false,
    hasErrors: false,
    currency: 1
  });
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [loading, setLoading] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const [value, setValue] = React.useState(0);
  const [switchChecked, setSwitchChecked] = useState(false);
  const filename = `SSB_${formData.ssbFilename}_${moment().format('DD-MMM-YYYY')}.csv`;

  const handleChange = (event, newValue) => {
    setValue(newValue);
    console.log(event);
  };

  const ProcessFileSchema = Yup.object().shape({
    // subjectcode: Yup.string().required('Province is required'),
    // nameofsubject: Yup.string().required('Province is required')
  });

  useEffect(() => {
    console.log('id is', id);
    if (id > 0) {
      getFileDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('id is again 22', formData);
  }, [formData]);

  const formik = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema: ProcessFileSchema,
    onSubmit: (values) => {
      console.log('custingo before that exe 2', values);
      // saveBill(values);
    }
  });

  if (formData.uploadDate) formData.uploadDate = moment(formData.uploadDate).format('yyyy-MM-DD');

  const matchClientsToFile = (e) => {
    setLoading(true);
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    fetch(`${baseUrl}/api/client/MatchDependantToMember?refId=${e.id}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((res) => res.json())
      .then(
        (result) => {
          getFileDetail();
          console.log('returned file analysis', result);
          setLoading(false);
          notifyPopup(`File Analyzed Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Analyzing File Details!: ${error}`, 'error');
        }
      );
  };

  const getFileDetail = async () => {
    setLoading(true);
    fetch(`${baseUrl}/api/client/GetDepUploadFile?refId=${id}`)
      .then((result) => result.json())
      .then(
        (result) => {
          console.log('GetDepUploadFile returned  ', result);
          setFormData(result.result);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Retrieving GetDepUploadFile!: ${error}`, 'error');
        }
      );
  };

  const createDependants = (e) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    console.log('create dependants', e);
    const jsonClient = [];
    jsonClient.push(e);
    console.log('bulk receipt stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/CreateDependantsFromFile?refId=${id}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // setFormData(result);
          getFileDetail();
          console.log('returned bulk', result);
          setLoading(false);
          notifyPopup(`Dependants Created Successfully!`, 'success');
          navigate(-1);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Creating Dependants!: ${error}`, 'error');
        }
      );
  };

  const removeMissingMembers = (e) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    const jsonClient = [];
    jsonClient.push(e);
    fetch(`${baseUrl}/api/client/RemoveUnmatchedDependants?refId=${id}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          notifyPopup(`Missing Dependants removed successfully!`, 'success');
          navigate(-1);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in removing Missing Members!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  console.log('formik.values.processState', formik.values.processState);

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Typography variant="h6" gutterBottom>
                Process Loaded Dependants...
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                  <Controls.Input name="refId" label="Ref Id" disabled />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.DateTime name="uploadDate" label="Date Uploaded" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="filename" label="File Name" />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.Input name="uploadedBy" label="User" />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Controls.SelectJson name="processState" label="Status" options={processStates} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.SelectJson name="fileType" label="File Type" options={fileTypes} />
                </Grid>
                <Grid
                  margin={2}
                  container
                  direction="row"
                  justifyContent="right"
                  alignItems="right"
                >
                  {formData.hasErrors && (
                    <Grid item xs={12} sm={1} marginRight={1}>
                      <Button
                        type="button"
                        variant="outlined"
                        color="error"
                        startIcon={<ReceiptIcon />}
                        disabled={formData.processState === 1 || formData.processState === 2}
                        onClick={() =>
                          setConfirmDialog({
                            isOpen: true,
                            title: 'Are you sure you want to process Current File',
                            subTitle: "You can't undo this action",
                            heading: 'Delete Unmatched Dependants',
                            color: '#FF0000',
                            onConfirm: () => {
                              removeMissingMembers({ id });
                            }
                          })
                        }
                      >
                        Remove Unmatched
                      </Button>
                    </Grid>
                  )}
                  <Grid item xs={12} sm={1} marginRight={1} ml={6}>
                    <Button
                      type="button"
                      variant="outlined"
                      color="primary"
                      startIcon={<ReceiptIcon />}
                      disabled={formData.processState === 1 || formData.processState === 2}
                      onClick={() =>
                        setConfirmDialog({
                          isOpen: true,
                          title: 'Are you sure you want to process Current File',
                          subTitle: "You can't undo this action",
                          heading: 'Run File Analysis',
                          color: '#76ff03',
                          onConfirm: () => {
                            matchClientsToFile({ id });
                          }
                        })
                      }
                    >
                      Link to Member
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={1} marginRight={1} mr={2} ml={6}>
                    <Button
                      type="button"
                      variant="outlined"
                      startIcon={<SaveIcon />}
                      disabled={
                        formik.values.processState === 0 || formik.values.processState === 2
                      }
                      onClick={() => createDependants()}
                    >
                      Create Dependants
                    </Button>
                  </Grid>
                  {/* <Grid item xs={12} sm={1} marginRight={1} mr={2} ml={6}>
                    <Button
                      type="button"
                      variant="outlined"
                      startIcon={<SaveIcon />}
                      disabled={formik.values.processState === 0}
                      onClick={() => downloadDocument()}
                    >
                      Download File
                    </Button>
                  </Grid> */}
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
          {formData.refId > 0 && (
            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label="Uploaded List" {...a11yProps(0)} />
                  <Tab label="Errors/Symptoms" {...a11yProps(1)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <DepUploadList id={id} />
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <DepUploadErrors id={id} />
              </CustomTabPanel>
            </Box>
          )}
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </CardContent>
      </Card>
    </Container>
  );
}
